import { render, staticRenderFns } from "./AdminReportPerformanceAlerts.vue?vue&type=template&id=35c7e5cd&scoped=true"
import script from "./AdminReportPerformanceAlerts.vue?vue&type=script&lang=js"
export * from "./AdminReportPerformanceAlerts.vue?vue&type=script&lang=js"
import style0 from "./AdminReportPerformanceAlerts.vue?vue&type=style&index=0&id=35c7e5cd&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c7e5cd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gl-apistage/apistage.greenlists.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35c7e5cd')) {
      api.createRecord('35c7e5cd', component.options)
    } else {
      api.reload('35c7e5cd', component.options)
    }
    module.hot.accept("./AdminReportPerformanceAlerts.vue?vue&type=template&id=35c7e5cd&scoped=true", function () {
      api.rerender('35c7e5cd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/pages/AdminReportPerformanceAlerts.vue"
export default component.exports